import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {BrandKitUpdateFromColorPalettePanelProps} from '@Components/panels/brand-kit-update-from-color-palette-panel/brand-kit-update-from-color-palette-panel.types';
import {useAppSelector} from '@/hooks';

export const PANEL_ID = 'brand-kit-update-modal-panel';

export type BrandKitUpdateFromColorPaletteModalProps = BrandKitUpdateFromColorPalettePanelProps;

export default function BrandKitUpdateFromColorPaletteModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.BRAND_KIT_UPDATE_FROM_COLOR_PALETTE_MODAL];
  });

  const height = 'auto';
  const width = '600px';
  const panelDirectoryName = 'brand-kit-update-from-color-palette-panel';

  return (
    <Modal modalId={MODALS_IDS.BRAND_KIT_UPDATE_FROM_COLOR_PALETTE_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width} isBottomSheetOnMobile>
      <LazyPanel
        panelDirectoryName={panelDirectoryName}
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openBrandKitUpdateFromColorPaletteModal = (props: BrandKitUpdateFromColorPaletteModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.BRAND_KIT_UPDATE_FROM_COLOR_PALETTE_MODAL,
      panelProps: props,
    })
  );
};
